import Store from '~/store'
import get from 'lodash/get'

export default {
    set(errors) {
        Store.dispatch('validation/setErrors', errors)
    },

    merge(errors) {
        Store.dispatch('validation/setErrors', {
            ...Store.getters['validation/getErrors'],
            ...errors,
        })
    },

    clear() {
        return Store.dispatch('validation/clearErrors', [])
    },

    clearFieldValidation(path) {
        return Store.dispatch('validation/removeErrorByField', path)
    },

    get(path) {
        return get(Store.getters['validation/getErrors'], path)
    },
}
